// @flow

import * as React from "react";

export type AddMessage = (message: React.Node, type: "success" | "failure") => void;

export type FlashMessageContextValue = {
  addMessage: AddMessage
};
const FlashMessageContext: React.Context = React.createContext<FlashMessageContextValue>({
  addMessage: () => {}
});

export default FlashMessageContext;
